import { Editor, TinyMCE } from "tinymce";
import { makeEditorModal } from "../Modal";
import { FeatureClass } from "../core/FeatureClass";
import { getData, insertToEditor, setWindowNode, toJsonHtml } from "../core/Utils";
import { ajaxSpin } from "../../Utils/utils";

declare let tinymce:TinyMCE

export function addTextToSpeech(editor:Editor){
    const config = {
        featureName: "texttospeech",
        id: "audio",
        tooltip: 'Sprache einfügen',
        icon: "speaker",
        editor: editor,
        menuItems: [{
            name: 'edit-tts',
            icon: 'edit-block',
            text: 'Bearbeiten',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                const data = getData(node);
                openModal(editor, command, data.text);
            }
        },
        {
            name: 'listen-tts',
            icon: 'speaker',
            text: 'Anhören',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                const data = getData(node);
                const url = data.url;
                const a = new Audio(url);
                a.volume = 0.65;
                a.play();
            }
        }],
        buttonAction: (command:string) => {
            openModal(editor, command);
        },
        commandAction: (data:Object) => {
            insertAudio(data);
        }
    }
    const feature = new FeatureClass(config);
    feature.addToEditor(editor);
}

function openModal(editor:Editor, command:string, text=''){
    const content = '<div class="convert-to-audio"><div class="row"><div class="col-7">' +
    '<p>Hier kannst du einen Text zu einer Audio-Datei umwandeln.</p>' +
    '</div><div class="col-5 text-end"><select id="voice" class="form-control form-select">' +
    '<option value="de-male1" selected>Mann - DE</option><option value="de-female1">Frau - DE</option>' +
    '<option value="us-male1">Mann - US</option><option value="us-female1">Frau - US</option>' +
    '<option value="uk-male1">Mann - UK</option><option value="uk-female1">Frau - UK</option>' +
    '</select></div></div>' +
    '<textarea id="audio-text" class="form-control" style="height: 200px;" placeholder="Der Text hieraus wird von einer Stimme gesprochen...">'+text+'</textarea>' +
    '</div>';

    const leftHtml = '<select id="audio-display-form" style="width: 100px;" class="form-control form-select"><option selected value="bar">Audio-bar</option><option value="icon1">Wort</option><option value="icon2">Satz</option></select>';

    const settings = {
        submitBtn: {
            text: 'Einfügen',
            class: 'add-mp3',
        },
        leftInput: {
            html: leftHtml,
        },
        faq: 14,
    }

    const onclick = function(modal){
        const text = modal.find("#audio-text").val();
        const voice = modal.find("#voice").val();
        const view = modal.find("#audio-display-form").val();
        convertTextToVoice(editor, command, text, voice, view, $(".add-mp3"));
        return true;
    }

    const modal = makeEditorModal('create-text-to-speech', 'Audiodatei erstellen', content, settings, onclick);
    $("#audio-text").focus();
}


function convertTextToVoice(editor:Editor, command:string, text:string, voice:string, view:string, btn){
    const config = {
        url: '/convert-text-to-speech',
        data: {
        //    action: "convert_text_to_audio",
            text: text,
            voice: voice,
            view: view,
        },
        success: function(data){
            successToast("Text wurde konvertiert", "Erfolg", 3500, true);
            const url = data.path;
            const identifier = data.id;
            tinymce.activeEditor.selection.collapse(false);

            const audioData = {
                text: text,
                view: view,
                identifier: identifier,
                url: url
            }
            editor.execCommand(command, audioData);

        },
        error: function(error){
            errorToast("Text konnte nicht zu Audio konvertiert werden", "Fehler", 8000);
        }
    }
    ajaxSpin(config, btn);
}

function insertAudio(data){

    const html = transformAudioForInsert(data);
    insertToEditor(html);
}

export function transformAudioForInsert(data){
    const jsonData = {
        url: data.url,
        text: data.text,
        icon: data.view,
        type: "audio",
    }
    const json = toJsonHtml(jsonData);

    let html = '';
    let add = '';
    if (data.view == "bar"){
        html = '<audio id="audio" class="prop-item" data-json="'+json+'" controls type="audio/mpeg" src='+data.url+'></audio>';
    } else {
        if (data.view == "icon1"){
            add = '-blue';
        } else if (data.view == "icon2"){
            add = '-green';
        }
        html = '<img id="audio" src="../wp-content/plugins/mawiwi-exams/assets/img/speaker-icon' + add + '.png" width="50px"' +
        ' height="auto" alt="|Audio|" data-json="' + json +'" class="mceNonEditable prop-item">';
    }
    return html;
}

interface AudioExportData {
    url: string;
    text: string;
    icon: string;
    type: string | "audio";
}

export function transformAudio(data:AudioExportData){
    let html = '';
  if (data.icon == "bar"){
    html = '<audio id="audio" controls type="audio/mpeg" src='+data.url+'></audio>';
  } else {
    let add = '';
    let text = '';
    if (data.icon == "icon1"){
      add = 'primary'
      text = 'Wort'
    } else if (data.icon == "icon2"){
      add = 'green';
      text = 'Satz'
    }
    console.log("HERE");
    html = '<span class="play-sound" data-audio="' + data.url + '" title="' + text + ' abspielen"><i class="fa fa-volume-down text-' + add + '"></i></span>'
  }
    return html;
}
